<template>
  <div>
    <b-row>
      <b-col
          md="2"
          xl="2"
      >
        <b-form-group label="Fahrer">
          <b-form-select
              v-model="driverId"
              :options="drivers"
              @change="Load"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="5"
          xl="5"
      >
        <b-form-group label="Von Datum">
          <b-form-datepicker
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              :start-weekday="1"
              locale="de-DE"
              color="danger"
              @context="onDateFromContext"

          />
        </b-form-group>
      </b-col>

      <b-col
          md="5"
          xl="5"
      >
        <b-form-group label="bis Datum">
          <b-form-datepicker
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              :start-weekday="1"
              locale="de-DE"
              color="danger"
              @context="onDateToContext"
          />
        </b-form-group>
      </b-col>

    </b-row>
    <b-row>
      <b-col
          md="12"
          xl="12"
      >

        <b-card-code :title="i.Name" v-for="i in items">
          <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :fields="fields"
              :items="i.Vouchers"
          >
            {{ i.Name }}
            <template #cell(Voucher)="data">
              {{ data.item.Vid }}
            </template>
            <template #cell(Date)="data">
              {{ formatDate(data.item.TravelDay) }}
            </template>
            <template #cell(From)="data">
              {{ data.item.Origin }}
            </template>
            <template #cell(To)="data">
              {{ data.item.Destination }}
            </template>
            <template #cell(Cash)="data">
              {{ FormatEuro(data.item.NetPrice) }} | {{ FormatEuro(data.item.Price) }}
            </template>
            <template #cell(Time)="data">
              <div v-show="data.item['extraInfo'] == null">
                {{ (data.item.TripRoute.TripFullDuration / 60 / 60).toFixed(2) }}
              </div>
              <div v-show="GetExtra(data.item['extraInfo'])">
                Fahrzeug-Km: {{GetExtra(data.item['extraInfo']) ? (data.item['extraInfo'].km/1000).toFixed(0) : ''}}<br>
                Fahrzeug-Zeit: {{GetExtra(data.item['extraInfo']) ? (data.item['extraInfo'].tripDuration / 60 / 60).toFixed(2) : ''}}<br>
                Fahrzeug-Diesel: {{GetExtra(data.item['extraInfo']) ? (data.item['extraInfo'].fuel)+'%' : ''}}<br>
              </div>
            </template>
          </b-table>

        </b-card-code>
      </b-col>
      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, VBTooltip, BAlert, BFormDatepicker, BDropdownDivider, BDropdownForm, BDropdownGroup
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Call',
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      date: {
        From: '01.01.23',
        To: '31.01.23'
      },
      drivers: [],
      driverId: 9,
      perPage: 2500,
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'Voucher',
          label: 'Voucher',
        },
        {
          key: 'Date',
          label: 'Tag',
        },
        {
          key: 'From',
          label: 'Von',
        },
        {
          key: 'To',
          label: 'Nach',
        },
        {
          key: 'Cash',
          label: 'Einnahmen',
        },
        {
          key: 'Time',
          label: 'Zeit',
        },
      ],
      items: [],

    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Fahrerstunden'
    })
    this.LoadDriverList();
    this.Load()
  },
  methods: {
    LoadDriverList() {
      this.$http.get(`/driver/list`)
          .then(resp => {
            resp.data.list.forEach(i => {
              this.drivers.push({

                text: i.Driver.DriverShortName,
                value: i.Driver.DId
              })
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.From = ctx.activeFormatted
        this.Load()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.To = ctx.activeFormatted
        this.Load()
      }
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    GetExtra(data) {
      console.log(data)
      return data != null;
    },
    clickCall(record, index) {

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    Load() {
      this.items = []
      if(this.driverId == 0) {
        return
      }
      if(this.date.From == '') {
        return
      }
      if(this.date.To == '') {
        return
      }
      const dateFrom = this.date.From.split('.')
      const dateTo = this.date.To.split('.')
      this.$http.post('/driver/vouchers', JSON.stringify({
        driverId : this.driverId,
        From: `${new Date('20' + dateFrom[2] + '-' + dateFrom[1] + '-' + dateFrom[0]).toDateString()}`,
        To : `${new Date('20' + dateTo[2] + '-' + dateTo[1] + '-' + dateTo[0]).toDateString()}`,
      }), { timeout: 30000 })
          .then(resp => {
            if (resp.data.success) {
              this.totalRows = resp.data.info.fullEntries
              resp.data.list.forEach(i => {
                console.log(i.Vouchers)

                this.items.push(i)
              })
            }
            console.log(this.items)

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
